import { createRoute } from "@tanstack/react-router";
import { appLayoutRoute } from "@/routes/layout-routes";
import { ProfileScreen } from "@/app/Profile/Screens/ProfileScreen";

export const profileRoute = createRoute({
  path: "/profile",
  getParentRoute: () => appLayoutRoute,
  component: ProfileScreen,
  head: () => ({
    meta: [
      {
        title: "My Profile - Imoova Admin",
      },
    ],
  }),
});
